const events = [
  {
    poster_url:
      "https://res.cloudinary.com/dmeicehn2/image/upload/v1758953281/Techfusion-poster-2k25_1__page-0001_ut2vki.jpg",

    event_name: "TECHFUSION 2k25",

    description:
      "TechFusion 2K25 brings you CloudVerse, CodeDuet, CodeCrush, and CheckMate - where tech, code, and strategy collide!",
  }
];

export default events;